import React from "react";
import "./DeleteChannelsBar.css";
import CheckBox from "../checkbox/CheckBox";
import { DeleteButton } from "../buttons/deleteButton/DeleteButton";

type props = {
  onDeletePress: () => void;
  onCheckBoxPress: (isChecked: boolean) => void;
};

export const DeleteChannelsBar: React.FC<props> = ({
  onDeletePress,
  onCheckBoxPress,
}) => {
  return (
    <div className="delete-channels-bar-container">
      <CheckBox onCheckBoxClicked={onCheckBoxPress} />
      <DeleteButton onPress={onDeletePress} />
    </div>
  );
};
